import React, { useEffect } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useSearchParams,
  Navigate,
  useLocation,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/main.scss";
import "./styles/desktop/tenant-defaults.scss";
import "./styles/settings.scss";
import "./styles/allintroductions.scss";
import "./styles/style-payment.css";
import "./styles/desktop/agent_dashboard.scss";
import "./styles/desktop/home.scss";
import "./styles/desktop/mls-listings.scss";
import Home from "./pages/v2/Home";
import NoPage from "./pages/NoPage";
import DeletedWantAd from "./pages/v2/DeletedWantAd";
import SelectYourPlan from "./pages/v2/SelectYourPlan";
import CompleteYourProfilePremium from "./pages/v2/CompleteYourProfilePremium";
import CompleteYourProfileDefault from "./pages/v2/CompleteYourProfileDefault";
import WantadDetails from "./pages/v2/WantadDetails";
import StrengthenInventory from "./pages/StrengthenInventory";
import CreateIframeWidget from "./pages/admin/CreateIframeWidget";
import IframeWidget from "./pages/embed/IframeWidget";
import IframeWidgetSearch from "./pages/embed/IframeWidgetSearch";
import ShowcaseEmbed from "./pages/embed/ShowcaseEmbed";
import "./App.css";
import { LoadingIndicator } from "./components/Common/LoadingIndicator";
import ImpersonationBanner from "./components/Common/ImpersonationBanner";
import { LoadingProvider } from "./context/LoadingContext";
import { pageURLs } from "@/constants";
import {
  getLocalStorage,
  loggedInUser,
} from "./helpers/common";
import useSSOCrossTabSync from "./hooks/useSSOCrossTabSync";
import useAnalyticsIdentify from "./hooks/useAnalyticsIdentify";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ViewClientDetails from "./pages/ViewClientDetails";
import MemberEditWantAd from "./pages/MemberEditWantAd";
import HomeLoadingSkeleton from "./pages/HomeLoadingSkeleton";
import GitchaPrivacyPolicy from "./pages/GitchaPrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import AgentWantAdConfirmation from "./pages/AgentWantAdConfirmation";
import InventoryDetails from "./pages/v2/InventoryDetails";
import MyFavorites from "./pages/MyFavorites";
import FavoriteClients from "./pages/FavoriteClients";
import ViewInventory from "./pages/ViewInventory";
import MyInventoryListing from "./pages/MyInventoryListing";
import Settings from "./pages/Settings";
import MemberEditInventory from "./pages/MemberEditInventory";
import InventoryConfirmation from "./pages/InventoryConfirmation";
import AgentCreateOrEditInventory from "./pages/AgentCreateOrEditInventory";
import GitchaMemberWelcome from "./pages/GitchaMemberWelcome";
import AllIntroductions from "./pages/AllIntroductions.js";
import ReceiveIntroduction from "./pages/ReceiveIntroduction";
import { LEGACY_RESULTS_PATH, RESULTS_PATH } from "./helpers/resultsCopy";
import LegacyResultsRedirect from "./components/ResultsPage/LegacyResultsRedirect";
import { GITCHA_PRO_PATH } from "./helpers/gitchaProPath";
import PassCodeRequest from "./pages/PassCodeRequest";
import InventoryAllSentIntroductions from "./pages/InventoryAllSentIntroductions";
import WantadDetailsSkeleton from "./pages/WantadDetailsSkeleton";
import Messaging from "./pages/Messaging";
import GitchaInventoryAddOnboard from "./pages/GitchaInventoryAddOnboard";


import {
  AgentMyInventory,
  AgentMyWantAdListing,
  AgentMyClients,
  AgentResults,
  AgentGitchaPro,
  AgentCreateWantAd,
  AgentEditWantAd,
  AgentCreateOrEditWantAdDraftListing,
  ChatPage,
} from "@/pages";
import { RequireCopilot } from "@/components/Common/RequireCopilot";

import {
  USER_INFO_KEY,
} from "./constants/common";
import {
  initializeChatMessageCountValue,
  setChatMessageCount,
  setChatMessages,
  setInappNotificationCount,
  setReceiveIntroCount,
  setDmMessageCount,
  setUnreadDmChatIds,
} from "./reducers/unReadStatus.js";
import { db } from "./firebase";
import { collection, onSnapshot, query, where, or } from "firebase/firestore";
import { useDispatch } from "react-redux";
import { loginOrSignUp } from "./helpers/message.js";
import {
  getInAppNotications,
  getIntroductions,
} from "./services/introductionService.js";
import { setsseData } from "./reducers/sseData.js";
import BuyerListingCreateWantAdForm from "@/form/BuyerListingCreateWantAdWeb.js";
import FormSubmissionSuccess from "./form/v2/FormSumbissionSuccess.js";
import InvestorDashboard from "./pages/InvestorDashboard.js";
import ShareIntroductionWeb from "./form/ShareIntroductionWeb.js";
import ErrorBoundary from "./components/Common/v2/ErrorBoundary/ErrorBoundary";
import PersistentDashboardShell from "./components/PersistentDashboardShell";
import UserTypeSelection from "./pages/v2/UserTypeSelection";
import AgentInfo from "./pages/AgentInfo";
import AgentDirectoryPage from "./pages/AgentDirectoryPage";
import ShowcaseHostedPage from "./pages/ShowcaseHostedPage";
import PropertyDemandPage from "./pages/PropertyDemandPage";
import LeadForwardConfirm from "./pages/LeadForwardConfirm";
import DemandReportPage, { DEMAND_REPORT_PATH } from "./pages/DemandReportPage";
import DirectMessages from "./pages/v2/DirectMessaging";
import AgentDashboard from "./pages/AgentDashboard";
import ConsumerCreateInventory from "./pages/ConsumerCreateInventory";
import CrossLoginCallback from "./pages/CrossLoginCallback";
import MessageConfirm from "./components/MessageConfirm";
import CrossLogoutCallback from "./pages/CrossLogoutCallback";
import SSOCallback from "./pages/SsoCallback";
import MlsListingDetail from "./pages/v2/MlsListingDetail";
import MlsListingMatches from "./pages/v2/MlsListingMatches";
import { removeLocalStorageData } from "@/helpers/removeLocalStorageData";
import useSessionReset from "@/hooks/useSessionReset";

const wantAdErrorFallback = (
  <div className="row m-0">
    <h2 className="text-center mt-5">
      Something went wrong. Please refresh and try again.
    </h2>
  </div>
);

// Must stay at module level: defining it inside App() remounts every route on each App re-render.
function RequireAuth({ children, roles }) {
  const user = loggedInUser();
  const userInfo = _.get(user, "userInfo", null);
  const usertype = parseInt(_.get(userInfo, "userType", null));
  const planStatus = _.get(userInfo, "planStatus", null);
  const userStatus = _.get(userInfo, "userStatus", null);
  let location = useLocation();

  const userHasRequiredRole = user && roles.includes(usertype) ? true : false;

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  if (!userHasRequiredRole) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  if (!planStatus || !userStatus) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
}

// const store = setupStore();
function App() {
useSSOCrossTabSync();
useAnalyticsIdentify();
useSessionReset();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const user = loggedInUser();
  const _userType = user?.userInfo?.userType;
  const location = useLocation();
  const passCodeStatus = process.env.REACT_APP_PASSCODE_STATUS;
  const pathName = _.get(location, "pathname", null)?.toLowerCase();
  const basicUrl = pathName.split("/")[1];
  const isEmbedRoute = basicUrl === "embed";

  useEffect(() => {
    removeLocalStorageData(); // to remove local storage data
  }, [pathName]);


  const UserId =
    _.get(user, "userInfo.userId", null) ||
    _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", null);

  // SSE integration
  useEffect(() => {
    if (isEmbedRoute) return; // no SSE for anonymous embed visitors
    let mount = true;
    let events;
    let timer;
    let createEvents = () => {
      // Close connection if open
      if (events) {
        events.close();
      }
      // Establishing an SSE connection
      events = new EventSource(
        process.env.REACT_APP_API_BASE_URL + "connect?userId=" + UserId,
      );
      events.onmessage = (event) => {
        if (mount) {
          const parsedData = JSON.parse(event.data);
          const formatedParsedData = JSON.parse(parsedData);
          const clientId = formatedParsedData?.subjectId;
          dispatch(setsseData(null));
          if (formatedParsedData?.messageType == "in-app") {
            dispatch(setsseData(formatedParsedData));

            getNotificationList(); // to set the unread in app message count
            if (formatedParsedData?.subjectType === 12) {
              const pathName = _.get(location, "pathname", null);
              const inventoryMatch = pathName?.match(/\/inventory-details\/(\d+)/);
              if (inventoryMatch?.[1]) {
                dispatch(setsseData(formatedParsedData));
              }
            }
          } else if (formatedParsedData?.messageType == "receiveIntroduction") {
            dispatch(setsseData(formatedParsedData));
            const wantAdId = null;
            let page = 1;
            getIntroductionList(page, wantAdId);
          } else if (formatedParsedData?.messageType == "exportNotes") {
            window.open(
              process.env.REACT_APP_S3_BASE_URL +
              "/ClientNotes/" +
              clientId +
              ".pdf",
              "_blank",
            );
          } else if (formatedParsedData?.messageType == "matchingComplete") {
            // Matching finished for a want-ad (subjectId). WantadDetails reads
            // this to flip the Matches tab live and refetch the count.
            dispatch(setsseData(formatedParsedData));
          }
        }
      };
      events.onerror = (err) => {
        console.log("err", err);
        // timer = setTimeout(() => {
        //   createEvents();
        // }, 1000);
      };
    };

    createEvents();
    return () => {
      mount = false;
      clearTimeout(timer);
      events.close();
    };
  }, [UserId]);

  /**
   * To set the unread inapp notidication count
   */
  const getNotificationList = async () => {
    const reqPayload = {};
    await getInAppNotications(reqPayload).then((response) => {
      if (response) {
        if (response.errorCode === 0) {
          dispatch(
            setInappNotificationCount(
              _.get(response, "result.unReadMessageCount", 0),
            ),
          );
        }
      }
    });
  };

  // receive Intro list
  const getIntroductionList = async (page, wantAdId) => {
    const userId = _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", "");
    const reqPayload = {
      userId: userId,
      wantAdId: wantAdId,
      page: page,
      limit: 1,
      isAccept: "1",
    };
    await getIntroductions(reqPayload).then((response) => {
      if (response) {
        const list = _.get(response, "result.List", null);
        if (response.errorCode === 0) {
          dispatch(
            setReceiveIntroCount(
              _.get(response, "result.unReadMessageCount", 0),
            ),
          );
        }
      }
    });
  };

  // api call for chat messages

  useEffect(() => {
    const userDetails = loggedInUser();
    let email = _.get(userDetails, "userInfo.email", null);
    if (email) {
      let login = loginOrSignUp(email);
      if (!login) {
        // navigate(pageURLs.home);
      } else {
        // api call for get receive intro count
        const wantAdId = null;
        let page = 1;
        getIntroductionList(page, wantAdId);
        getNotificationList();
      }
    }
  }, []);

  useEffect(() => {
    if (isEmbedRoute) return; // no Firestore listeners in embed
    const q = query(
      collection(db, "Introduction"),
      or(
        where("inventroyCreatedId", "==", UserId),
        where("wantAdCreatedId", "==", UserId),
      ),
    );

    const unsubscribe = onSnapshot(q, (QuerySnapshot) => {
      let fetchedMessages = [];
      let orderd = [];
      QuerySnapshot.forEach((doc) => {
        fetchedMessages.push({ ...doc.data(), id: doc.id });
      });

      dispatch(setChatMessages(fetchedMessages));

      orderd = fetchedMessages?.filter(
        (item) => item.isaccepted == true && item.isdeleted == false,
      );

      if (orderd && orderd.length > 0) {
        dispatch(initializeChatMessageCountValue());
        orderd.forEach((msg) => {
          if (msg?.wantAdCreatedId == UserId) {
            if (msg?.isWantAdOwnerHasUnreadMessage == true) {
              dispatch(setChatMessageCount());
            }
          } else {
            if (msg?.isInventoryOwnerHasUnreadMessage == true) {
              dispatch(setChatMessageCount());
            }
          }
        });
      }
    }, () => {
      // A failed listener (blocked Firestore, permission-denied) would leave the
      // inbox badge waiting forever; mark the chat source as loaded.
      dispatch(setChatMessages([]));
    });

    return () => unsubscribe();
  }, [UserId]);

  useEffect(() => {
    if (isEmbedRoute || !UserId) return;

    const q = query(
      collection(db, "DirectChat"),
      where("users", "array-contains", UserId),
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      let dmUnread = 0;
      let unreadIds = [];
      snapshot.forEach((doc) => {
        const data = doc.data();
        if (data.unreadBy && data.unreadBy.includes(UserId)) {
          dmUnread++;
          unreadIds.push(doc.id);
        }
      });
      dispatch(setDmMessageCount(dmUnread));
      dispatch(setUnreadDmChatIds(unreadIds));
    }, () => {
      dispatch(setUnreadDmChatIds([]));
    });

    return () => unsubscribe();
  }, [UserId]);

  return (
    <LoadingProvider>
      <LoadingIndicator />
      <ToastContainer position="bottom-center" className="toast-message" />
      {/* Embed widgets are chrome-less by design (see SSE/Firestore guards
          below) - an impersonated admin's own banner has no business
          appearing inside a partner's embedded iframe. */}
      {!isEmbedRoute && <ImpersonationBanner />}
      {isEmbedRoute ? (
        <Routes>
          {/* Chrome-less MLS iframe widget (app host, no shell) */}
          <Route
            path="/embed/w/:widgetKey"
            element={
              <ErrorBoundary>
                <IframeWidget />
              </ErrorBoundary>
            }
            exact
          />
          {/* Searchable variant - distinct URL, opt-in per partner, does not
              affect the plain widget above. */}
          <Route
            path="/embed/w/:widgetKey/search"
            element={
              <ErrorBoundary>
                <IframeWidgetSearch />
              </ErrorBoundary>
            }
            exact
          />
          <Route
            path="/embed/s/:key"
            element={
              <ErrorBoundary>
                <ShowcaseEmbed />
              </ErrorBoundary>
            }
            exact
          />
        </Routes>
      ) : window.location.origin.includes(
        process.env.REACT_APP_BUYERLISTING_SERVICE_BASE_URL,
      ) ? (
        <Routes>
          {/* BuyerListing Form */}

          <Route
            path="/form/:id"
            element={
              <ErrorBoundary>
                <BuyerListingCreateWantAdForm />
              </ErrorBoundary>
            }
            exact
          />

          <Route
            path="/confirmation"
            element={
              <ErrorBoundary>
                <FormSubmissionSuccess />
              </ErrorBoundary>
            }
            exact
          />
          <Route
            path="/form/introduction/:id"
            element={
              <ShareIntroductionWeb />
            }
            exact
          />
        </Routes>
      ) : (
        <PersistentDashboardShell>
        <Routes>
          {/* passcode barrier route */}
          <Route
            path="/"
            element={passCodeStatus == 2 ? <PassCodeRequest /> : <Home />}
            exact
          />
          <Route
            path="/home"
            element={
              <Home />
            }
            exact
          />
          <Route path="/match" element={<Home />} exact />

          <Route path={pageURLs.selectYourPlan} element={<SelectYourPlan />} />
          <Route
            path={pageURLs.completeYourProfilePremium}
            element={<CompleteYourProfilePremium />}
          />
          <Route
            path={pageURLs.completeYourProfileDefault}
            element={<CompleteYourProfileDefault />}
          />
          <Route
            path={pageURLs.adminIframeWidgets}
            element={
              <RequireAuth roles={[5]}>
                <CreateIframeWidget />
              </RequireAuth>
            }
            exact
          />

          <Route path="*" element={<NoPage />} />
          <Route
            path={`${pageURLs.wantAdDetails}/:wantAdId`}
            element={<WantadDetails />}
            exact
          />
          <Route
            path={pageURLs.agentMyWantAdListings}
            element={
              <RequireAuth roles={[2]}>
                <AgentMyWantAdListing />
              </RequireAuth>
            }
            exact
          />
          <Route
            path={pageURLs.agentInventoryListing}
            element={
              <RequireAuth roles={[2]}>
                <AgentMyInventory />
              </RequireAuth>
            }
            exact
          />
          <Route
            path={RESULTS_PATH}
            element={
              <RequireAuth roles={[2]}>
                <AgentResults />
              </RequireAuth>
            }
            exact
          />
          <Route path={LEGACY_RESULTS_PATH} element={<LegacyResultsRedirect />} exact />
          <Route
            path={GITCHA_PRO_PATH}
            element={
              <RequireAuth roles={[2]}>
                <AgentGitchaPro />
              </RequireAuth>
            }
            exact
          />
          <Route
            path={DEMAND_REPORT_PATH}
            element={
              <RequireAuth roles={[2]}>
                <DemandReportPage />
              </RequireAuth>
            }
            exact
          />
          <Route
            path={pageURLs.agentMyClients}
            element={
              <RequireAuth roles={[2]}>
                <AgentMyClients />
              </RequireAuth>
            }
            exact
          />
          <Route
            path={pageURLs.agentChat}
            element={
              <RequireAuth roles={[2]}>
                <RequireCopilot>
                  <ChatPage />
                </RequireCopilot>
              </RequireAuth>
            }
            exact
          />
          <Route
            path={pageURLs.agentChatConversation}
            element={
              <RequireAuth roles={[2]}>
                <RequireCopilot>
                  <ChatPage />
                </RequireCopilot>
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/agent-dashboard"
            element={
              <RequireAuth roles={[2]}>
                <AgentDashboard />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/investor-dashboard"
            element={
              <RequireAuth roles={[1]}>
                <InvestorDashboard />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/view-client"
            element={
              <RequireAuth roles={[2]}>
                <ViewClientDetails />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/loading-skeleton"
            element={<HomeLoadingSkeleton />}
            exact
          />
          <Route
            path={pageURLs.agentEditwantad}
            element={
              <RequireAuth roles={[1]}>
                <MemberEditWantAd />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/privacy-policy"
            element={<GitchaPrivacyPolicy />}
            exact
          />
          <Route path="/terms-of-service" element={<TermsOfService />} exact />

          <Route path={pageURLs.SSOCallback} element={<SSOCallback />} exact />
          <Route path={pageURLs.crossLoginCallback} element={<CrossLoginCallback />} exact />
          <Route path="/message/confirm" element={<MessageConfirm />} exact />
          <Route path="/lead-forward/confirm" element={<LeadForwardConfirm />} exact />
          <Route path={pageURLs.crossLogoutCallback} element={<CrossLogoutCallback />} exact />
          <Route path="/404-not-found" element={<NoPage />} exact />
          <Route
            path={pageURLs.deletedWantAd}
            element={<DeletedWantAd />}
            exact
          />
          <Route
            path={pageURLs.agentCreatewantadMainScreen}
            element={<AgentCreateOrEditWantAdDraftListing />}
            exact
          />
          <Route
            path={pageURLs.agentCreatewantad}
            element={
              <RequireAuth roles={[2]}>
                <ErrorBoundary fallback={wantAdErrorFallback}>
                  <AgentCreateWantAd />
                </ErrorBoundary>
              </RequireAuth>
            }
            exact
          />
          <Route
            path={`${pageURLs.editWantAdForAgents}/:id`}
            element={
              <RequireAuth roles={[2]}>
                <ErrorBoundary fallback={wantAdErrorFallback}>
                  <AgentEditWantAd />
                </ErrorBoundary>
              </RequireAuth>
            }
            exact
          />
          <Route
            path={pageURLs.agentWantAdConfirmation}
            element={
              <RequireAuth roles={[2]}>
                <AgentWantAdConfirmation />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/wantad-details-skeleton"
            element={<WantadDetailsSkeleton />}
            exact
          />
          <Route
            path="/create-inventory"
            element={
              <RequireAuth roles={[1, 2]}>
                {_userType === 2 ? (
                  <AgentCreateOrEditInventory />
                ) : (
                  <ConsumerCreateInventory />
                )}
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/strengthen-inventory"
            element={
              <RequireAuth roles={[1, 2]}>
                <StrengthenInventory />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/inventory-details/:inventoryId"
            element={
              <RequireAuth roles={[1, 2]}>
                <InventoryDetails />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/my-favorites"
            element={
              <RequireAuth roles={[1, 2]}>
                <MyFavorites />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/favorite-clients"
            element={
              <RequireAuth roles={[2]}>
                <FavoriteClients />
              </RequireAuth>
            }
            exact
          />
          <Route path="/view-inventory" element={<ViewInventory />} exact />
          <Route
            path={pageURLs.consumerInventoryListing}
            element={
              <RequireAuth roles={[1, 2]}>
                <MyInventoryListing />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/member-edit-Inventory"
            element={
              <RequireAuth roles={[1]}>
                <MemberEditInventory />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/inventory-confirmation"
            element={
              <RequireAuth roles={[1, 2]}>
                <InventoryConfirmation />
              </RequireAuth>
            }
            exact
          />

          <Route path="/enter-passcode" element={<PassCodeRequest />} exact />
          <Route
            path={pageURLs.gitchaMemberWelcome}
            element={
              <RequireAuth roles={[1, 2]}>
                <GitchaMemberWelcome />
              </RequireAuth>
            }
            exact
          />

          <Route
            path="/settings"
            element={
              <RequireAuth roles={[1, 2]}>
                <Settings />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/add-new-card"
            element={
              <RequireAuth roles={[1, 2]}>
                <Settings addNewCard={true} />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/edit-agent-profile"
            element={
              <RequireAuth roles={[1, 2]}>
                <Settings editAgentProfile={true} />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/all-introductions"
            element={
              <RequireAuth roles={[1, 2]}>
                <AllIntroductions />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/view-introduced-property"
            element={
              <RequireAuth roles={[1, 2]}>
                <ReceiveIntroduction />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/view-all-introductions"
            element={
              <RequireAuth roles={[1, 2]}>
                <InventoryAllSentIntroductions />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/messages"
            element={
              <RequireAuth roles={[1, 2]}>
                <Messaging />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/direct-messages"
            element={
              <RequireAuth roles={[1, 2]}>
                <DirectMessages />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/inventory-onboard"
            element={<GitchaInventoryAddOnboard />}
            exact
          />


          <Route
            path="/user-type"
            element={
              <UserTypeSelection />
            }
            exact
          />

          <Route
            path={pageURLs.agentDirectory}
            element={
              <AgentDirectoryPage />
            }
            exact
          />
          <Route
            path="/agents/:state"
            element={
              <AgentDirectoryPage />
            }
            exact
          />
          <Route
            path="/agents/:state/:town"
            element={
              <AgentDirectoryPage />
            }
            exact
          />
          <Route
            path="/brokerage/:slug/buyers"
            element={
              <ShowcaseHostedPage />
            }
            exact
          />
          <Route path="/brokerage/:slug/buyers/:item" element={<ShowcaseHostedPage />} exact />
          <Route path="/agent-info/:slug/buyers" element={<ShowcaseHostedPage owner="agent" />} exact />
          <Route path="/agent-info/:slug/buyers/:item" element={<ShowcaseHostedPage owner="agent" />} exact />
          <Route
            path="/demand/:token"
            element={
              <PropertyDemandPage />
            }
            exact
          />
          <Route
            path="/agent-info/:slug"
            element={
              <AgentInfo />
            }
            exact
          />
          <Route
            path="/mls-listing/:listingKey"
            element={
              <RequireAuth roles={[2]}>
                <MlsListingDetail />
              </RequireAuth>
            }
            exact
          />
          <Route
            path="/mls-listing/:listingKey/matches"
            element={
              <RequireAuth roles={[2]}>
                <MlsListingMatches />
              </RequireAuth>
            }
            exact
          />
        </Routes>
        </PersistentDashboardShell>
      )}
    </LoadingProvider>
  );
}

export default App;
